import { request, unwrap } from '../client';
import type { ApiResponse, CopyLocalesResponse, CopyLocalesUpdate } from '../types';

const BASE = '/api/saas-admin/brands';

/**
 * SASADM-0155 — the brand's per-locale copy (saas-auth SASATH-0346, handoff
 * "go" §3.5). A save changes the theme etag ("go" §4.2).
 */
export const brandCopyLocalesApi = {
  async get(brandId: number): Promise<CopyLocalesResponse> {
    const res = await request<ApiResponse<CopyLocalesResponse>>(
      'GET',
      `${BASE}/${brandId}/copy-locales`,
    );
    return unwrap(res);
  },

  /** Sends only the given cells; 400 `VALIDATION_FAILED`, 429 `RATE_LIMITED`. */
  async save(brandId: number, locales: CopyLocalesUpdate['locales']): Promise<CopyLocalesResponse> {
    const body: CopyLocalesUpdate = { locales };
    const res = await request<ApiResponse<CopyLocalesResponse>>(
      'PUT',
      `${BASE}/${brandId}/copy-locales`,
      { json: body },
    );
    return unwrap(res);
  },
};
